import { Injectable, signal } from '@angular/core';

/**
 * Service to track authentication state and route context across the application.
 * Used by the auth interceptor to determine whether a 401 should be treated
 * as a session expiration on a protected route.
 *
 * Defaults to false (public route). Only set to true by the protected route guard.
 */
@Injectable({ providedIn: 'root' })
export class AuthStateService {
    readonly isOnProtectedRoute = signal(false);

    setOnProtectedRoute(value: boolean): void {
        this.isOnProtectedRoute.set(value);
    }
}
